import React from 'react'
import { FirestoreSystemMessage } from '../../../types/chat'
import { SystemMessageType } from '../../../enums/SystemMessageType'

interface Props {
  message: FirestoreSystemMessage
  declineMatchingRequest: (matchingRequestId: number) => void
  acceptMatchingRequest: (matchingRequestId: number) => void
}

export const ChatSystemMessage: React.FC<Props> = ({
  message,
  declineMatchingRequest,
  acceptMatchingRequest,
}) => {
  const getMessageContent = () => {
    // マッチングリクエスト受信
    if (
      message.messageType === SystemMessageType.RECEIVE_MATCHING_REQUEST ||
      message.messageType === SystemMessageType.SENT_MATCHING_REQUEST
    ) {
      return (
        <div className="mb-4">
          <div className="bg-main-lightgreen border-l-4 border-main-green p-4 flex items-start gap-3">
            <span className="material-icons text-main-green text-xl relative -top-1">
              info
            </span>
            <div className="flex-1">
              <p className="text-sm font-bold text-main-green mb-1">
                {message.messageType ===
                SystemMessageType.RECEIVE_MATCHING_REQUEST
                  ? 'マッチングリクエストが届いています'
                  : 'マッチングリクエストを送信しました'}
              </p>
              <p className="text-xs text-main-darkgray mb-3">
                {message.messageType ===
                SystemMessageType.RECEIVE_MATCHING_REQUEST
                  ? '承認するとメッセージのやり取りができるようになります'
                  : '承認されるとメッセージのやり取りができるようになります'}
              </p>
            </div>
          </div>
        </div>
      )
    }

    // 返信ボタン
    if (
      message.messageType ===
        SystemMessageType.RESPONSE_MATCHING_REQUEST_BUTTON &&
      message.matchingRequestId !== null
    ) {
      return (
        <div className="flex gap-3 justify-end">
          <button
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onClick={() => declineMatchingRequest(message.matchingRequestId!)}
            className="px-6 py-2 border border-main-gray rounded-lg text-main-darkgray bg-main-white hover:bg-main-lightgray transition-colors"
          >
            リクエストを拒否
          </button>
          <button
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onClick={() => acceptMatchingRequest(message.matchingRequestId!)}
            className="px-6 py-2 bg-main-green text-main-white rounded-lg hover:opacity-90 transition-opacity"
          >
            リクエストを承認
          </button>
        </div>
      )
    }

    if (
      message.messageType === SystemMessageType.ACCEPT_MATCHING_REQUEST ||
      message.messageType === SystemMessageType.REJECT_MATCHING_REQUEST
    ) {
      return (
        <div className="mb-4">
          <div className="bg-main-lightgreen border-l-4 border-main-green p-4 flex items-start gap-3">
            <span className="material-icons text-main-green text-xl relative -top-1">
              {message.messageType === SystemMessageType.ACCEPT_MATCHING_REQUEST
                ? 'check_circle'
                : 'cancel'}
            </span>
            <div className="flex-1">
              <p className="text-sm font-bold text-main-green">
                {message.messageType ===
                SystemMessageType.ACCEPT_MATCHING_REQUEST
                  ? 'マッチングリクエストが承認されました'
                  : 'マッチングリクエストが拒否されました'}
              </p>
            </div>
          </div>
        </div>
      )
    }

    return null
  }

  return <div key={message.id}>{getMessageContent()}</div>
}
